import {BlockType} from "../../model/markdown/MarkdownText"
import {ParsedBlock} from "./blockParseService"

class CodeBlockParserService {
    isCodeBlock(curChar: string, line: string, offset: number): boolean {
        if (curChar !== '`') {
            return false
        }
        offset++
        if (offset >= line.length || line[offset] !== '`') {
            return false
        }
        offset++
        return offset < line.length && line[offset] === '`'
    }

    getCodeBlock(line: string, offset: number, lines: Array<string>, lineNo: number): ParsedBlock {
        const offsets: Array<number> = []
        const contents: Array<string> = []
        lineNo++
        let hint = line.substring(offset)
        while (hint.length > 0 && hint.charAt(0) === '`') {
            hint = hint.substring(1)
        }
        while (lineNo < lines.length) {
            let lineOffset = 0
            const checkLine = lines[lineNo]
            let curChar = checkLine[lineOffset]
            let patchedLine = checkLine
            while (patchedLine.length > 0 && patchedLine.charAt(0) === ' ') {
                patchedLine = patchedLine.substring(1)
                lineOffset++
                if (patchedLine.length > 0) {
                    curChar = patchedLine[0]
                }
            }
            if (this.isCodeBlock(curChar, checkLine, lineOffset)) {
                break
            }
            offsets.push(0)
            contents.push(checkLine.substring(0))
            lineNo++
        }
        const subBlocks: Array<ParsedBlock> = []
        for (let i = 0; i < offsets.length; i++) {
            subBlocks.push({
                type: BlockType.CODE,
                offset: offsets[i],
                content: contents[i],
                subBlocks: [],
                lineSkipped: 0,
                startFrom: 1,
                hint: '',
                indent: 0
            })
        }
        return {
            type: BlockType.CODE,
            offset: offset,
            content: line.substring(offset),
            lineSkipped: offsets.length + 1,
            subBlocks,
            startFrom: 1,
            hint: hint,
            indent: 0
        }
    }
}

export const codeBlockParserService = new CodeBlockParserService()
